export const _bookingData = {
  date_from: '',
  date_to: '',
  rooms: [
    {
      room_code: '',
      offer: null,
      rate_category: null,
    },
  ],
  extras: [],
  card: {
    token: 'E67TY8GQ27X',
    provider: 'braintree',
  },
  customer: {
    email: 'titular@digitalhype.mx',
    first_name: 'Titular',
    last_name: 'Prueba',
    phone_number: '+12312332123',
    address: 'Address',
    city: 'Mexico',
    postal_code: '03000',
    country: 'GB',
  },
};
